import { Card } from "antd";
import React from "react";

const CompanyCard: React.FC<{ children: React.ReactNode; title: string }> = ({ children, title }) => {
  return (
    <Card title={title} style={{ width: "100%", marginBottom: "16px" }}>
      {children}
    </Card>
  );
};

export default CompanyCard;
